export const iconFontAwesomeAnimalsBugs = (
	<i className="fa-solid fa-bugs"></i>
);
